import { Button, ButtonProps, useMediaQuery, useTheme } from '@mui/material';
import { useFormState } from 'hooks/useFormState';

/**
 * back button for integration with react-hook-form
 * @props {ButtonProps} - ButtonProps from ReactHookForm
 * @returns FormBackButton
 */
export function FormBackButton(props: ButtonProps) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const { currentFormSectionIndex, setCurrentSectionIndex } = useFormState();

    const isOnFirstPage = currentFormSectionIndex === 0;

    const handleOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        return setCurrentSectionIndex(currentFormSectionIndex - 1);
    };

    return !isOnFirstPage ? (
        <Button
            onClick={handleOnClick}
            data-testid="form-back-button"
            variant="contained"
            color="primary"
            fullWidth={props.fullWidth ?? fullScreen}
            {...props}
        >
            Back
        </Button>
    ) : null;
}
